import { Sounds } from '../interfaces/sounds.interface';

export const sounds: Sounds = {
  p: {
    initial: [
      { name: 'peas' },
      { name: 'pear' },
      { name: 'pig' },
      { name: 'panda' },
      { name: 'penguin' },
      { name: 'potatoes' },
      { name: 'porridge' },
      { name: 'pan' },
      { name: 'painting' },
      { name: 'park' },
      { name: 'paper' },
    ],

    medial: [
      { name: 'hippo' },
      { name: 'apple' },
      { name: 'puppet' },
      { name: 'purple' },
      { name: 'shampoo' },
      { name: 'puppy' },
      { name: 'happy' },
      { name: 'shopping' },
      { name: 'hopping' },
      { name: 'saucepan' },
    ],

    final: [
      { name: 'soap' },
      { name: 'sheep' },
      { name: 'soup' },
      { name: 'stop' },
      { name: 'up' },
      { name: 'cup' },
      { name: 'map' },
      { name: 'help' },
      { name: 'ship' },
      { name: 'zip' },
    ],
  },

  b: {
    initial: [
      { name: 'ball' },
      { name: 'bug' },
      { name: 'bed' },
      { name: 'bee' },
      { name: 'birthday' },
      { name: 'bath' },
      { name: 'boat' },
      { name: 'bottle' },
      { name: 'boy' },
      { name: 'button' },
      { name: 'bananna' },
      { name: 'bike' },
    ],

    medial: [
      { name: 'robot' },
      { name: 'baby' },
      { name: 'ladybird' },
      { name: 'ribbon' },
      { name: 'rabbit' },
      { name: 'goodbye' },
      { name: 'robin' },
      { name: 'rubber' },
      { name: 'cobweb' },
      { name: 'strawberries' },
      { name: 'cheeseburger' },
    ],

    final: [
      { name: 'crab' },
      { name: 'globe' },
      { name: 'web' },
      { name: 'icecube' },
      { name: 'job' },
      { name: 'club' },
      { name: 'doorknob' },
      { name: 'bob' },
      { name: 'lightbulb' },
    ],
  },

  t: {
    initial: [
      { name: 'tea' },
      { name: 'television' },
      { name: 'toes' },
      { name: 'turtle' },
      { name: 'tennis' },
      { name: 'tomato' },
      { name: 'tent' },
      { name: 'table' },
      { name: 'toilet' },
      { name: 'time' },
      { name: 'toys' },
      { name: 'tiger' },
    ],

    medial: [
      { name: 'pasta' },
      { name: 'docutor' },
      { name: 'potato' },
      { name: 'empty' },
      { name: 'button' },
      { name: 'football' },
      { name: 'guitar' },
      { name: 'lighthouse' },
      { name: 'catapiller' },
      { name: 'hotel' },
      { name: 'painting' },
    ],

    final: [
      { name: 'hat' },
      { name: 'cat' },
      { name: 'rat' },
      { name: 'bat' },
      { name: 'hot' },
      { name: 'foot' },
      { name: 'feet' },
      { name: 'coat' },
      { name: 'light' },
      { name: 'white' },
      { name: 'night' },
      { name: 'rabbit' },
    ],
  },

  d: {
    initial: [
      { name: 'dog' },
      { name: 'donkey' },
      { name: 'daisy' },
      { name: 'donught' },
      { name: 'dinosaur' },
      { name: 'door' },
      { name: 'doll' },
      { name: 'clay' },
      { name: 'dinner' },
      { name: 'dolphin' },
    ],

    medial: [
      { name: 'candle' },
      { name: 'birthday' },
      { name: 'puddle' },
      { name: 'panda' },
      { name: 'medal' },
      { name: 'spider' },
      { name: 'pudding' },
      { name: 'tadpole' },
      { name: 'ladder' },
    ],

    final: [
      { name: 'red' },
      { name: 'food' },
      { name: 'dad' },
      { name: 'bed' },
      { name: 'bird' },
      { name: 'slide' },
      { name: 'bread' },
      { name: 'head' },
      { name: 'lizard' },
      { name: 'road' },
    ],
  },

  c: {
    initial: [
      { name: 'cat' },
      { name: 'carrot' },
      { name: 'comb' },
      { name: 'cow' },
      { name: 'castle' },
      { name: 'king' },
      { name: 'key' },
      { name: 'cup' },
      { name: 'camel' },
    ],

    medial: [
      { name: 'cookie' },
      { name: 'rocket' },
      { name: 'jacket' },
      { name: 'donkey' },
      { name: 'bucket' },
      { name: 'chicken' },
      { name: 'cracker' },
      { name: 'necklace' },
      { name: 'ticket' },
      { name: 'pocket' },
    ],

    final: [
      { name: 'book' },
      { name: 'duck' },
      { name: 'shark' },
      { name: 'bike' },
      { name: 'sock' },
      { name: 'snake' },
      { name: 'snack' },
      { name: 'rock' },
      { name: 'walk' },
      { name: 'milk' },
    ],
  },

  g: {
    initial: [
      { name: 'go' },
      { name: 'girl' },
      { name: 'goat' },
      { name: 'gate' },
      { name: 'game' },
      { name: 'guitar' },
      { name: 'goal' },
      { name: 'goose' },
      { name: 'goodbye' },
      { name: 'golf' },
      { name: 'gorilla' },
    ],

    medial: [
      { name: 'biujrger' },
      { name: 'klangeroo' },
      { name: 'yoghurt' },
      { name: 'sugar' },
      { name: 'tiger' },
      { name: 'finger' },
      { name: 'alligator' },
      { name: 'dragon' },
      { name: 'eagle' },
      { name: 'magvazine' },
      { name: 'seagull' },
    ],

    final: [
      { name: 'leg' },
      { name: 'bug' },
      { name: 'dog' },
      { name: 'bag' },
      { name: 'mug' },
      { name: 'frog' },
      { name: 'pig' },
      { name: 'log' },
      { name: 'slug' },
      { name: 'egg' },
      { name: 'jug' },
    ],
  },

  f: {
    initial: [
      { name: 'five' },
      { name: 'fingers' },
      { name: 'foot' },
      { name: 'feet' },
      { name: 'food' },
      { name: 'fairy' },
      { name: 'farm' },
      { name: 'football' },
      { name: 'fan' },
    ],

    medial: [
      { name: 'breakfast' },
      { name: 'coffee' },
      { name: 'elephant' },
      { name: 'waffle' },
      { name: 'toffee' },
      { name: 'golfish' },
      { name: 'sofa' },
      { name: 'muffin' },
      { name: 'puffin' },
    ],

    final: [
      { name: 'girraffe' },
      { name: 'leaf' },
      { name: 'roof' },
      { name: 'scawrf' },
      { name: 'chef' },
      { name: 'golf' },
      { name: 'shelf' },
      { name: 'wolf' },
      { name: 'calf' },
    ],
  },

  v: {
    initial: [
      { name: 'violin' },
      { name: 'van' },
      { name: 'vest' },
      { name: 'vegatableds' },
      { name: 'volcano' },
      { name: 'village' },
      { name: 'vase' },
      { name: 'vet' },
      { name: 'vaccumcleaner' },
    ],

    medial: [
      { name: 'driveway' },
      { name: 'seven' },
      { name: 'beaver' },
      { name: 'diver' },
      { name: 'driver' },
      { name: 'envelope' },
      { name: 'shaviong' },
      { name: 'seventy' },
      { name: 'river' },
    ],

    final: [
      { name: 'glove' },
      { name: 'olive' },
      { name: 'five' },
      { name: 'love' },
      { name: 'cave' },
      { name: 'drive' },
      { name: 'wave' },
      { name: 'beehive' },
      { name: 'sleeve' },
    ],
  },

  m: {
    initial: [
      { name: 'mouse' },
      { name: 'moon' },
      { name: 'monkey' },
      { name: 'motorbike' },
      { name: 'melon' },
      { name: 'mermaid' },
      { name: 'mountains' },
      { name: 'milk' },
      { name: 'mice' },
    ],

    medial: [
      { name: 'lemon' },
      { name: 'family' },
      { name: 'camera' },
      { name: 'tomato' },
      { name: 'animals' },
      { name: 'numbers' },
      { name: 'woman' },
      { name: 'camel' },
      { name: 'hammer' },
      { name: 'christmas' },
    ],

    final: [
      { name: 'game' },
      { name: 'lamb' },
      { name: 'stream' },
      { name: 'thumb' },
      { name: 'time' },
      { name: 'farm' },
      { name: 'jam' },
      { name: 'drum' },
      { name: 'swim' },
    ],
  },

  n: {
    initial: [
      { name: 'knees' },
      { name: 'nest' },
      { name: 'necklace' },
      { name: 'nurse' },
      { name: 'nail' },
      { name: 'night' },
      { name: 'nine' },
      { name: 'numbers' },
      { name: 'northpole' },
    ],

    medial: [
      { name: 'pencil' },
      { name: 'sunglasses' },
      { name: 'bananna' },
      { name: 'doghnut' },
      { name: 'dinner' },
      { name: 'planet' },
      { name: 'rainbow' },
      { name: 'dinosaur' },
      { name: 'pineapple' },
    ],

    final: [
      { name: 'sun' },
      { name: 'van' },
      { name: 'moon' },
      { name: 'green' },
      { name: 'spoon' },
      { name: 'barn' },
      { name: 'pen' },
      { name: 'pan' },
      { name: 'can' },
      { name: 'fan' },
    ],
  },

  ng: {
    initial: [],
    medial: [],
    final: [
      { name: 'wing' },
      { name: 'ring' },
      { name: 'sing' },
      { name: 'king' },
      { name: 'lung' },
      { name: 'swing' },
      { name: 'song' },
      { name: 'string' },
      { name: 'tongue' },
    ],
  },

  s: {
    initial: [
      { name: 'sun' },
      { name: 'soap' },
      { name: 'soup' },
      { name: 'sock' },
      { name: 'seal' },
      { name: 'sink' },
      { name: 'saw' },
      { name: 'suitcaser' },
      { name: 'salt' },
      { name: 'seven' },
    ],

    medial: [
      { name: 'glasses' },
      { name: 'sunglasses' },
      { name: 'pencil' },
      { name: 'fossil' },
      { name: 'insect' },
      { name: 'grasshopper' },
      { name: 'dinosaur' },
      { name: 'bicycle' },
      { name: 'policecar' },
    ],

    final: [
      { name: 'bus' },
      { name: 'face' },
      { name: 'ice' },
      { name: 'grass' },
      { name: 'hourse' },
      { name: 'nurse' },
      { name: 'purse' },
      { name: 'dress' },
      { name: 'mouse' },
      { name: 'house' },
      { name: 'lettuce' },
    ],
  },

  z: {
    initial: [
      { name: 'zoo' },
      { name: 'zebra' },
      { name: 'zero' },
      { name: 'zip' },
      { name: 'zookeeper' },
      { name: 'xylophone' },
      { name: 'zigzag' },
      { name: 'zest' },
      { name: 'zoom' },
      { name: 'zone' },
    ],

    medial: [
      { name: 'music' },
      { name: 'cheesecake' },
      { name: 'wizard' },
      { name: 'lizard' },
      { name: 'magazine' },
      { name: 'raisins' },
      { name: 'scissors' },
      { name: 'daisy' },
      { name: 'freezer' },
    ],

    final: [
      { name: 'cheese' },
      { name: 'knees' },
      { name: 'nose' },
      { name: 'rose' },
      { name: 'hose' },
      { name: 'babies' },
      { name: 'dogs' },
      { name: 'bees' },
      { name: 'prize' },
    ],
  },

  l: {
    initial: [
      { name: 'lemon' },
      { name: 'ladder' },
      { name: 'ladybird' },
      { name: 'lips' },
      { name: 'lime' },
      { name: 'lizard' },
      { name: 'leap' },
      { name: 'letter' },
      { name: 'lunch' },
      { name: 'lion' },
      { name: 'lamb' },
    ],

    medial: [
      { name: 'yellow' },
      { name: 'noun' },
      { name: 'police' },
      { name: 'volcano' },
      { name: 'elephant' },
      { name: 'jelly' },
      { name: 'telescope' },
      { name: 'eleven' },
      { name: 'television' },
      { name: 'balloons' },
    ],

    final: [
      { name: 'ball' },
      { name: 'nail' },
      { name: 'seal' },
      { name: 'pool' },
      { name: 'shell' },
      { name: 'tail' },
      { name: 'tool' },
      { name: 'bell' },
      { name: 'owl' },
    ],
  },

  w: {
    initial: [
      { name: 'wall' },
      { name: 'water' },
      { name: 'watch' },
      { name: 'watefall' },
      { name: 'wing' },
      { name: 'window' },
      { name: 'web' },
      { name: 'wave' },
      { name: 'white' },
      { name: 'whale' },
    ],

    medial: [
      { name: 'homework' },
      { name: 'micreowave' },
      { name: 'fireworks' },
      { name: 'sandwich' },
      { name: 'seaweed' },
      { name: 'shower' },
      { name: 'owl' },
      { name: 'halloween' },
      { name: 'towel' },
    ],
    final: [],
  },

  r: {
    initial: [
      { name: 'red' },
      { name: 'rose' },
      { name: 'roof' },
      { name: 'rug' },
      { name: 'rock' },
      { name: 'radio' },
      { name: 'rabbiotr' },
      { name: 'rice' },
      { name: 'robot' },
      { name: 'rug' },
      { name: 'rope' },
      { name: 'rectangle' },
    ],

    medial: [
      { name: 'carrot' },
      { name: 'parrot' },
      { name: 'cereal' },
      { name: 'squirrel' },
      { name: 'blueberries' },
      { name: 'strawberries' },
      { name: 'blackberries' },
      { name: 'camera' },
      { name: 'fairy' },
    ],
    final: [],
  },

  sh: {
    initial: [
      { name: 'shoe' },
      { name: 'shut' },
      { name: 'sheep' },
      { name: 'ship' },
      { name: 'shop' },
      { name: 'shjorts' },
      { name: 'shampoo' },
      { name: 'shower' },
      { name: 'shapes' },
    ],

    medial: [
      { name: 'cushion' },
      { name: 'fishing' },
      { name: 'milkshake' },
      { name: 'ocean' },
      { name: 'marshellows' },
      { name: 'seashells' },
      { name: 'tissues' },
      { name: 'sunshine' },
      { name: 'washingmachine' },
    ],

    final: [
      { name: 'fish' },
      { name: 'brush' },
      { name: 'bush' },
      { name: 'dish' },
      { name: 'paintbrush' },
      { name: 'toothbrush' },
      { name: 'nailpolish' },
      { name: 'splash' },
      { name: 'hairbrush' },
    ],
  },

  tch: {
    initial: [
      { name: 'cheese' },
      { name: 'chair' },
      { name: 'chicken' },
      { name: 'chocolate' },
      { name: 'chick' },
      { name: 'chimes' },
      { name: 'chin' },
      { name: 'children' },
      { name: 'chips' },
    ],

    medial: [
      { name: 'teacher' },
      { name: 'kitchen' },
      { name: 'ketchup' },
      { name: 'lunchbox' },
      { name: 'armchair' },
      { name: 'marching' },
      { name: 'nachos' },
      { name: 'matching' },
      { name: 'reaching' },
      { name: 'patches' },
      { name: 'catching' },
      { name: 'watching' },
    ],

    final: [
      { name: 'peach' },
      { name: 'beach' },
      { name: 'lunch' },
      { name: 'torch' },
      { name: 'coach' },
      { name: 'branch' },
      { name: 'bench' },
      { name: 'catch' },
      { name: 'match' },
      { name: 'watch' },
    ],
  },

  j: {
    initial: [
      { name: 'jam' },
      { name: 'jar' },
      { name: 'jacket' },
      { name: 'jelly' },
      { name: 'giraffe' },
      { name: 'juice' },
      { name: 'jellybeans' },
      { name: 'jellyfish' },
      { name: 'jigsaw' },
      { name: 'jeans' },
      { name: 'jupiter' },
    ],

    medial: [
      { name: 'oranges' },
      { name: 'surgeon' },
      { name: 'magician' },
      { name: 'gingerbread' },
      { name: 'sausages' },
      { name: 'energy' },
      { name: 'solidery' },
      { name: 'magic' },
      { name: 'pyjamas' },
      { name: 'fireengine' },
    ],

    final: [
      { name: 'cabbage' },
      { name: 'fridge' },
      { name: 'bridge' },
      { name: 'orange' },
      { name: 'bandage' },
      { name: 'spoinge' },
      { name: 'cage' },
      { name: 'page' },
      { name: 'garage' },
    ],
  },

  zh: {
    initial: [],
    medial: [
      { name: 'measuringtape' },
      { name: 'treasure' },
      { name: 'beige' },
      { name: 'leisure' },
      { name: 'division' },
      { name: 'treasure' },
      { name: 'asia' },
      { name: 'measure' },
      { name: 'collage' },
    ],
    final: [],
  },

  h: {
    initial: [
      { name: 'house' },
      { name: 'hat' },
      { name: 'hospital' },
      { name: 'hair' },
      { name: 'hammer' },
      { name: 'hippo' },
      { name: 'hand' },
      { name: 'heart' },
      { name: 'horse' },
      { name: 'hamster' },
    ],

    medial: [
      { name: 'beehive' },
      { name: 'birdhouse' },
      { name: 'dollshouse' },
      { name: 'lighthouse' },
      { name: 'playhouse' },
      { name: 'foprehead' },
      { name: 'seahorse' },
      { name: 'grasshopper' },
      { name: 'superhero' },
    ],
    final: [],
  },
};
